import TimelineItem from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/Mission/TimelineItem"
import TimelineItemForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/TimelineItemForm";
import { Button } from "@/components/ui"
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import { useState } from "react"
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const MissionTimeline = () => {
    const { templatePayload:data } = useMicroSiteContext();
      const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';

  const [showForm, setShowForm] = useState(false);
  return (
    <div className="flex relative flex-col w-full p-4 lg:p-8 gap-6  justify-center" >
      <VerticalTimeline layout={"1-column-left"} lineColor="#D9D9D9" className="w-full !p-0">
      {data.missionTimeLineSection.missionTimeLineSectionDetails.map((item, index) => (
        // Item index is passed to help identify which item is being deleted because multiple items can have the same content and there is no unique id
        <VerticalTimelineElement key={index} contentStyle={{ border: "transparent", borderRadius: '0px', padding: '0px', marginLeft: "7.5rem", boxShadow: "none" }}   iconClassName="bg-[#d9d9d9] border-[#d9d9d9] !shadow-none" >
          <TimelineItem  data={item} itemIndex={index} />
        </VerticalTimelineElement>
      ))}
    </VerticalTimeline>

    {showForm && (
       <TimelineItemForm setShowForm={setShowForm} />
    )}

{ isEdit &&   <div className="mt-12">
      <Button className="w-full bg-forestGreen-200 border border-dashed !border-forestGreen-100 !text-forestGreen-100 hover:!text-white" onClick={()=>{
        setShowForm(true)
      }} >Add New Mission Section</Button>
    </div>}
    </div>
    
  )
}

export default MissionTimeline